import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/v2/:id?",
    name: "V2",
    component: () => import(/* webpackChunkName: "v2" */ "../views/V2.vue"),
  },
  {
    path: "/:id?",
    name: "V1",
    component: () => import(/* webpackChunkName: "v1" */ "../views/V1.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
